// extracted by mini-css-extract-plugin
export default {"startnow":"StartNow_startnow__B4UK1","startnow__title":"StartNow_startnow__title__fhvB1","startnow__inner":"StartNow_startnow__inner__6RbCK"};